"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateInspectionApprovalBodyDto = instanceOfUpdateInspectionApprovalBodyDto;
exports.UpdateInspectionApprovalBodyDtoFromJSON = UpdateInspectionApprovalBodyDtoFromJSON;
exports.UpdateInspectionApprovalBodyDtoFromJSONTyped = UpdateInspectionApprovalBodyDtoFromJSONTyped;
exports.UpdateInspectionApprovalBodyDtoToJSON = UpdateInspectionApprovalBodyDtoToJSON;
exports.UpdateInspectionApprovalBodyDtoToJSONTyped = UpdateInspectionApprovalBodyDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateInspectionApprovalBodyDto interface.
 */
function instanceOfUpdateInspectionApprovalBodyDto(value) {
    if (!('isApproved' in value) || value['isApproved'] === undefined)
        return false;
    return true;
}
function UpdateInspectionApprovalBodyDtoFromJSON(json) {
    return UpdateInspectionApprovalBodyDtoFromJSONTyped(json, false);
}
function UpdateInspectionApprovalBodyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'isApproved': json['isApproved'],
    };
}
function UpdateInspectionApprovalBodyDtoToJSON(json) {
    return UpdateInspectionApprovalBodyDtoToJSONTyped(json, false);
}
function UpdateInspectionApprovalBodyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'isApproved': value['isApproved'],
    };
}
